import { SchedulingSmsPolicyComponent } from 'app/components/scheduling-sms-policy/SchedulingSmsPolicyComponent'
import { useSchedulingSmsPolicy } from 'app/components/scheduling-sms-policy/useSchedulingSmsPolicy'

export default function SchedulingSmsPrivacyPage() {
  return <SchedulingSmsPolicyComponent policy="privacy" {...useSchedulingSmsPolicy()} />
}
